export default __webpack_public_path__ + "static/with-rocket-868261a5a9d5d0e57c814a3dc6052338.webp";